import React from "react";
import { Tab, styled } from "@mui/material";

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    color: theme.palette.secondary.light,
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "none",

    padding: "0px 24px",
    minWidth: "200px",

    transition: "font-weight 50ms linear",

    "&.Mui-selected": {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  })
);

export { StyledTab as Tab };
